var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 7.438A18.2 18.2 0 0 0 16.817 25.62c0 6.675 4.208 11.639 8.277 16.441 3.751 4.425 7.294 8.6 7.294 13.772A2.433 2.433 0 0 0 35 58.241a2.434 2.434 0 0 0 2.613-2.408c0-5.167 3.542-9.347 7.293-13.772 4.069-4.8 8.277-9.766 8.277-16.441A18.2 18.2 0 0 0 35 7.438zm8.38 33.33c-3.818 4.505-7.767 9.164-7.767 15.065 0 .379-.469.408-.613.408-.229 0-.612-.053-.612-.408 0-5.9-3.949-10.56-7.768-15.065-3.836-4.527-7.8-9.207-7.8-15.148a16.183 16.183 0 0 1 32.366 0c-.003 5.942-3.97 10.621-7.806 15.148z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 18.038a7.9 7.9 0 1 0 7.9 7.9 7.91 7.91 0 0 0-7.9-7.9zm0 13.8a5.9 5.9 0 1 1 5.9-5.9 5.907 5.907 0 0 1-5.9 5.901zM17.364 47.306H5.24l4.172-4.173A1 1 0 0 0 8 41.719L2.213 47.5a1 1 0 0 0 0 1.414L8 54.7a1 1 0 0 0 1.414-1.414l-3.985-3.98h11.935a1 1 0 1 0 0-2zm50.423.194L62 41.719a1 1 0 1 0-1.414 1.414l3.984 3.984H52.636a1 1 0 0 0 0 2H64.76l-4.173 4.172A1 1 0 1 0 62 54.7l5.786-5.785a1 1 0 0 0 0-1.414z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistance);
export default __webpack_public_path__ + "static/media/distance.d65fc702b42d45dea04700d0b3172e72.svg";
export { ForwardRef as ReactComponent };